import React from 'react';

import ViewProject from './ViewProject';

interface ViewProjectIndexProps {
  projectId: any;
  setMethod: () => void;
}

const ViewProjectIndex: React.FC<ViewProjectIndexProps> = ({
  projectId,
  setMethod,
}) => {
  return <ViewProject projectId={projectId} setMethod={setMethod} />;
};

export default ViewProjectIndex;
